(function () {
  function getPageSize(root) {
    var carousel = root.querySelector('[data-ss-products-carousel]');
    var configured = parseInt(carousel?.getAttribute('data-page-size'), 10);
    if (!Number.isFinite(configured) || configured <= 0) configured = 4;
    if (window.matchMedia('(max-width: 620px)').matches) return 1;
    if (window.matchMedia('(max-width: 900px)').matches) return Math.min(2, configured);
    return configured;
  }

  function initCarousel(root, resetPage) {
    var carousel = root.querySelector('[data-ss-products-carousel]');
    if (!carousel) return;

    if (!carousel.dataset.ssCarouselReady) {
      carousel.dataset.ssCarouselReady = '1';

      var prev = carousel.querySelector('[data-ss-products-carousel-prev]');
      var next = carousel.querySelector('[data-ss-products-carousel-next]');

      prev?.addEventListener('click', function () {
        var current = parseInt(carousel.dataset.ssCarouselPage || '0', 10) || 0;
        carousel.dataset.ssCarouselPage = String(current - 1);
        renderCarousel(root);
      });

      next?.addEventListener('click', function () {
        var current = parseInt(carousel.dataset.ssCarouselPage || '0', 10) || 0;
        carousel.dataset.ssCarouselPage = String(current + 1);
        renderCarousel(root);
      });

      window.addEventListener('resize', function () {
        renderCarousel(root);
      });
    }

    if (resetPage) carousel.dataset.ssCarouselPage = '0';
    renderCarousel(root);
  }

  function renderCarousel(root) {
    var carousel = root.querySelector('[data-ss-products-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-ss-products-carousel-track]');
    var cards = track ? Array.from(track.querySelectorAll('[data-ss-carousel-card]')) : [];
    var prev = carousel.querySelector('[data-ss-products-carousel-prev]');
    var next = carousel.querySelector('[data-ss-products-carousel-next]');
    var status = root.querySelector('[data-ss-products-carousel-status]');
    var pageSize = getPageSize(root);
    var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
    var page = parseInt(carousel.dataset.ssCarouselPage || '0', 10) || 0;

    if (page >= totalPages) page = totalPages - 1;
    if (page < 0) page = 0;
    carousel.dataset.ssCarouselPage = String(page);

    cards.forEach(function (card, index) {
      var visible = index >= page * pageSize && index < (page + 1) * pageSize;
      card.hidden = !visible;
    });

    if (prev) prev.disabled = page <= 0 || cards.length <= pageSize;
    if (next) next.disabled = page >= totalPages - 1 || cards.length <= pageSize;

    if (status) {
      if (cards.length <= pageSize) {
        status.textContent = '';
      } else {
        status.textContent = 'Showing planners ' + (page * pageSize + 1) + '–' + Math.min((page + 1) * pageSize, cards.length) + ' of ' + cards.length;
      }
    }
  }

  function activatePanel(root, panelId, tab) {
    root.querySelectorAll('[data-ss-products-tab]').forEach(function (button) {
      var active = button.getAttribute('data-panel') === panelId;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-ss-products-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-panel') !== panelId;
    });

    if (tab) {
      var eyebrow = root.querySelector('[data-ss-products-eyebrow]');
      var heading = root.querySelector('[data-ss-products-heading]');
      var viewAll = root.querySelector('[data-ss-products-view-all]');

      if (eyebrow) eyebrow.textContent = tab.getAttribute('data-eyebrow') || '';
      if (heading) heading.textContent = tab.getAttribute('data-heading') || '';

      if (viewAll) {
        var label = tab.getAttribute('data-view-all-label') || '';
        var link = tab.getAttribute('data-view-all-link') || '';
        viewAll.textContent = label;
        viewAll.href = link || '#';
        viewAll.hidden = !label || !link;
      }
    }

    if (panelId === 'all') {
      initCarousel(root, true);
    }
  }

  function initSection(root) {
    if (root.dataset.ssHomeProductsReady) return;
    root.dataset.ssHomeProductsReady = '1';

    var tabs = root.querySelectorAll('[data-ss-products-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activatePanel(root, tab.getAttribute('data-panel'), tab);
      });
    });

    var defaultPanel = root.getAttribute('data-default-panel') || 'essentials';
    var defaultTab =
      root.querySelector('[data-ss-products-tab][data-panel="' + defaultPanel + '"]') || tabs[0];
    activatePanel(root, defaultTab.getAttribute('data-panel'), defaultTab);
  }

  function boot() {
    document.querySelectorAll('[data-ss-home-products]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
